import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function playerBetsRouteI18n(): string {
  return (appRoutesI18nCache['player-bets'] ??= $localize`:url-segment@@player-bets-url-segment:player-bets`);
}
